import { ReactElement } from 'react'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { useAtom, useAtomValue } from 'jotai'
import { useLocation } from 'react-router-dom'
import featureFlags from 'const/featureFlags'
import getMFEConfig from 'helpers/getMFEConfig'
import { makeAPaymentModalContainerId } from 'const/modalContainerId'
import { useAccountSummary, useCreditAccounts } from 'const/syfApiQueries'
import findAccount from 'helpers/findAccount'
import getHelpNumber from 'helpers/getHelpNumbers'
import getLanguageFromStorage from 'helpers/getLanguageFromStorage'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import triggerQualtrics from 'helpers/triggerQualtrics'
import PaymentModal from 'make-a-payment'
import routes from 'const/routes'
import { analyticsConfig } from 'syf-js-utilities/helpers/triggerAnalyticsEvent'

const pathToPageInfo = {
  [routes.ACCOUNT_SERVICES]: {
    PageFunction: 'account services',
    PageKind: 'account services'
  },
  [routes.ACTIVITY]: {
    PageFunction: 'activity',
    PageKind: 'activity'
  },
  // needs to be updated dynamically - currently updating with default info
  [routes.PROMOTIONS]: {
    PageFunction: 'promo_tab',
    PageKind: 'activity'
  }
}

const MakePaymentModal = (): ReactElement => {
  const [{ modalId, metadata }, updateModalStatus] = useAtom(modalStatusAtom)
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const { data: { accounts = [] } = {} } = useCreditAccounts()
  const { data: accountSummary } = useAccountSummary(selectedAccount)
  const location = useLocation()

  const account = findAccount(accounts, selectedAccount)
  const accountLast4 = account?.info?.accountLast4
  const clientId = accountSummary?.product?.clientId
  const { type: productType } = account?.product || {}
  const helpNumber = getHelpNumber(clientId, productType)
  const { hosts } = getMFEConfig('mfe')
  const mapFeatureFlags = {
    isDigitalCollectionsEnabled: featureFlags.isDigitalCollectionsEnabled,
    isLateFeeDateEnabled: featureFlags.isLateFeeDateEnabled,
    isManagePaymentMethodsEnabled: featureFlags.isManagePaymentMethodsEnabled,
    isSavingCheckingEnabled: featureFlags.isSavingCheckingEnabled
  }

  const lang = getLanguageFromStorage()

  const handleClose = () => {
    // update pageInfo based on the page where MAP is opened/closed
    const currentPathname = location.pathname
    const pageInfo = pathToPageInfo[currentPathname] ?? {
      PageFunction: 'dashboard',
      PageKind: 'multiaccount'
    }
    triggerAnalyticsEvent(pageInfo)
    updateModalStatus('', '')
  }

  return (
    <PaymentModal
      id="make-a-payment"
      analyticsConfig={analyticsConfig}
      accountLast4={accountLast4}
      containerId={makeAPaymentModalContainerId(selectedAccount)}
      isOpen={modalId === 'MAP'}
      handleClose={handleClose}
      accountId={selectedAccount}
      lang={lang}
      apiErrorCallback={(error) => error}
      featureFlags={mapFeatureFlags}
      hosts={hosts}
      helpNumber={helpNumber}
      handleCloseOnConversion={() => {
        triggerQualtrics()
      }}
      additionalProps={metadata?.MAP}
    />
  )
}

export default MakePaymentModal
